export type LicenceImageState = "unopened" | "loading" | "readable" | "unavailable";

/** Keep disabled actions and their visible explanations based on identical rules. */
export function internationalReviewBlockers(input: {
  busy: boolean;
  canDecide: boolean;
  bookingStatus: string;
  contextIsCurrent: boolean;
  verificationHold: boolean;
  notes: string;
  allAttestationsChecked: boolean;
  images: Record<"front" | "back", LicenceImageState>;
}): { approve: string[]; decline: string[] } {
  const common: string[] = [];
  if (input.busy) common.push("A decision is being saved. Please wait.");
  if (!input.canDecide) {
    if (!input.contextIsCurrent) common.push("The licence session or issuing country changed. Refresh to review the current file.");
    else if (!input.verificationHold) common.push("This booking no longer has a driver hold and does not need this review.");
    else common.push(`This booking (${input.bookingStatus}) is no longer eligible for review. Refresh to remove it from the active queue.`);
  }
  if (!input.notes.trim()) common.push("Enter review notes to approve, or a reason to decline.");
  const approve = [...common];
  for (const side of ["front", "back"] as const) {
    const state = input.images[side];
    if (state === "unopened") approve.push(`Open View ${side} and inspect that side of the licence.`);
    if (state === "loading") approve.push(`Wait for the ${side} licence image to finish loading.`);
    if (state === "unavailable") approve.push(`The ${side} licence image is unavailable. Refresh or request fresh licence verification.`);
  }
  if (!input.allAttestationsChecked) approve.push("Confirm all three licence, driving and insurance attestations.");
  return { approve, decline: common };
}
